import { MetricsDaemon } from './MetricsDaemon';
function runMetricsDaemon() {
  const daemonInstance = MetricsDaemon.instance();
  daemonInstance.run();
  return daemonInstance;
}
export { runMetricsDaemon };